import React, { FunctionComponent } from "react"
import ChoiceInput, { IChoiceInputProps, ChoiceInputType } from "components/ChoiceInput/ChoiceInput"

const Checkbox: FunctionComponent<React.PropsWithChildren<Omit<IChoiceInputProps, "type">>> = (props) => {
    return <ChoiceInput
        {...props}
        type={ChoiceInputType.checkbox} />
}

export default Checkbox
